import React, { useState, useEffect, useRef } from 'react';
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Link, Navigate, resolvePath } from "react-router-dom";
import {config} from "../shared/config";
import * as util from '../shared/commons';
import axios, { all } from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import { Image } from "primereact/image";
import ShowError from "../shared/ShowError";
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import { Col, Form, Row } from 'react-bootstrap';
import EduMonthCombo from '../combos/EduMonthCombo';
import ShowVideo from '../shared/ShowVideo';
import FinalScoreSave from './FinalScoreSave';



export default function SchoolGradeSheetCreate(props) {
    const toast = useRef(null);
    const [errorVisible, setErorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [saving, setSaving] = useState(false);
    const [fieldDegreeVisible, setFieldDegreeVisible] = useState(true);
    const [loadingFieldDegree, setLoadingFieldDegree] = useState(false);
    const [classCourseVisible, setClassCourseVisible] = useState(false);
    const [loadingClassCourse, setLoadingClassCourse] = useState(false);
    const [saveLevelAndGrade, setSaveLevelAndGrade] = useState(false);
    const [gradeSheetSettedGradeCount, setGradeSheetSettedGradeCount] = useState(0);
    const [all_students_classes, setAll_students_classes] = useState([]);

    const [editFormVisible, setEditFormVisible] = useState(false);
    const [schoolClassId, setSchoolClassId] = useState("");
    const [schoolClassDegree, setSchoolClassDegree] = useState(-1);
    const [courseId, setCourseId] = useState("");

    
    const [fieldDegreeList, setFieldDegreeList] = useState([]);
    const [classCourseList, setClassCourseList] = useState([]);
    const [classList, setClassList] = useState([]);
    const [month, setMonth] = useState(null);
    const [field, setField] = useState("");
    const [degree, setDegree] = useState(-1);
    const [currentClassInd, setCurrentClassInd] = useState(-1);
    

    useEffect(() => {
        setLoadingFieldDegree(true);
        var params = {login:util.getTrustedUser()};
        var url = config.Server+`/school/field-degree/list/get`;
        console.log("params is>", params);
        console.log("url is>", url);
        axios
            .post(url, params )
            .then(res => {
                var response = res.data;
                if(response.state === "ok"){
                    response = response.data;
                    console.log("response is>", response);
                    
                    setFieldDegreeList(response);
                    
                    setLoadingFieldDegree(false);
                    
                }
                else{
                    setErrorMessage(response.message);
                    setErorVisible(true);
                }
            })
            .catch(error => {
                setErrorMessage(error.code + "," + error.message);
                setErorVisible(true);
            });

    }, []);
    const btnContinuClick = function(row){
        if((month == null)||(month == {})||(month == "")||(month <= 0)){
            setErorVisible(true);
            setErrorMessage("ماه تحصیلی را مشخص نمائید");
            return;
        }
        setSaving(false);
        setField(row.field.id);
        setDegree(row.degree);

        setClassCourseVisible(true);
        setLoadingClassCourse(true);
        setFieldDegreeVisible(false);
        
        var params = {login:util.getTrustedUser(), fieldId:row.field.id, degree:row.degree, monthNo:month};
        var url = config.Server+`/school/month/grade-sheet/check/list`;
        console.log("params is>", params);
        console.log("url is>", url);
        axios
            .post(url, params )
            .then(res => {
                var response = res.data;
                if(response.state === "ok"){
                    response = response.data;
                    console.log("response is>", response);
                    
                    setClassCourseList(response);
                    var classes = [];
                    for(var i=0;i<response.items.length;i++){
                        if(classes.findIndex(x=>x.id == response.items[i].schoolClass.id)>=0)continue;
                        classes.push({id:response.items[i].schoolClass.id, name:response.items[i].schoolClass.name, count:0});
                    }
                    console.log("classes is>", classes)
                    setClassList(classes);
                    setLoadingClassCourse(false);
                    setFieldDegreeVisible(false);
                    
                }
                else{
                    setFieldDegreeVisible(true);
                    setErrorMessage(response.message);
                    setErorVisible(true);
                    setLoadingClassCourse(false);
                    setClassCourseVisible(false);
                }
            })
            .catch(error => {
                setFieldDegreeVisible(true);
                setErrorMessage(error.code + "," + error.message);
                setErorVisible(true);
                setLoadingClassCourse(false);
                setClassCourseVisible(false);
            });

    }
    const createGradeSheet = function (classInd){
        setSaving(true);
        var params = {login:util.getTrustedUser(), fieldId:field, schoolClassId:classList[classInd].id, degree:degree, monthNo:month};
        var url = config.Server+`/school/month/grade-sheet/create`;
        console.log("params is>", params);
        console.log("url is>", url);
        axios
            .post(url, params )
            .then(res => {
                var response = res.data;
                if(response.state === "ok"){
                    response = response.data;
                    console.log("response is>", response);
                    var classes = [...classList];
                    classes[classInd].count = response;
                    setClassList(classes);

                    if(classInd == (classList.length-1)){
                        var all = 0;
                        for(var ii=0;ii<classList.length;ii++){
                            all += classList[ii].count;
                        }
                        setErrorMessage(all + " کارنامه با موفقيت ایجاد گردید");
                        setErorVisible(true);
                        // setLoadingClassCourse(false);
                        // setFieldDegreeVisible(true);
                        // setClassCourseVisible(false);
                        setSaving(false);
                    }
                    else{
                        createGradeSheet(classInd + 1);
                    }
                    
                }
                else{
                    setErrorMessage(response.message);
                    setErorVisible(true);
                    setSaving(false);
                }
            })
            .catch(error => {
                setErrorMessage(error.code + "," + error.message);
                setErorVisible(true);
                setSaving(false);
            });
    }
    const createGradeSheetLevels = function(){
        setSaving(true);
        var params = {login:util.getTrustedUser(), fieldId:field, schoolClassId:"", degree:degree, monthNo:month};
        var url = config.Server+`/school/month/grade-sheet/level-grade/create`;
        console.log("params is>", params);
        console.log("url is>", url);
        axios
            .post(url, params )
            .then(res => {
                var response = res.data;
                if(response.state === "ok"){
                    response = response.data;
                    console.log("response is>", response);

                    setErrorMessage(response + " کارنامه با موفقيت ایجاد گردید");
                    setErorVisible(true);
                    setSaving(false);
                    
                }
                else{
                    setErrorMessage(response.message);
                    setErorVisible(true);
                    setSaving(false);
                }
            })
            .catch(error => {
                setErrorMessage(error.code + "," + error.message);
                setErorVisible(true);
                setSaving(false);
            });
    }
    const createGradeSheetLevelsStart = function(){
        setSaving(true);
        setSaveLevelAndGrade(true);
        setAll_students_classes([]);
        setGradeSheetSettedGradeCount(0);
        var params = {login:util.getTrustedUser(), fieldId:field, schoolClassId:"", degree:degree, monthNo:month};
        var url = config.Server+`/school/month/grade-sheet/level-grade/create/start`;
        console.log("params is>", params);
        console.log("url is>", url);
        axios
            .post(url, params )
            .then(res => {
                var response = res.data;
                if(response.state === "ok"){
                    response = response.data;
                    console.log("response is>", response);
                    setAll_students_classes(response);
                    createGradeSheetLevelsBySteps(response, 0);
                }
                else{
                    setErrorMessage(response.message);
                    setErorVisible(true);
                    setSaving(false);
                    setSaveLevelAndGrade(false);
                }
            })
            .catch(error => {
                setErrorMessage(error.code + "," + error.message);
                setErorVisible(true);
                setSaving(false);
                setSaveLevelAndGrade(false);
            });
    }
    const createGradeSheetLevelsBySteps = function(allStudents, step){
        var max = 5;
        var students = [];
        var startInd = step * max;
        var endInd = startInd + max;
        if(endInd>= allStudents.length) endInd = allStudents.length;
        for(var i=startInd;i<endInd;i++){
            students.push({studentId:allStudents[i].studentId, schoolClassId:allStudents[i].schoolClassId});
        }
        var params = {login:util.getTrustedUser(), fieldId:field, students:students, degree:degree, monthNo:month};
        var url = config.Server+`/school/month/grade-sheet/level-grade/create/by-steps`;
        console.log("params is>", params);
        console.log("url is>", url);
        axios
            .post(url, params )
            .then(res => {
                var response = res.data;
                if(response.state === "ok"){
                    if(endInd>= allStudents.length){
                        setErrorMessage(allStudents.length + " کارنامه با موفقيت ایجاد گردید");
                        setErorVisible(true);
                        setSaving(false);
                        setSaveLevelAndGrade(false);
                    }
                    else{
                        setGradeSheetSettedGradeCount(endInd);
                        createGradeSheetLevelsBySteps(allStudents, step+1);
                    }
                    
                }
                else{
                    setErrorMessage(response.message);
                    setErorVisible(true);
                    setSaving(false);
                }
            })
            .catch(error => {
                setErrorMessage(error.code + "," + error.message);
                setErorVisible(true);
                setSaving(false);
            });
    }
    const EditTeacherScores = function(row){        
        var schoolClass = row.schoolClass;
        var course = row.course;
        console.log("schoolClass is>", schoolClass)
        console.log("course is>", course)
        console.log("month is>", month)
        localStorage.setItem("CurrentSchoolClass", JSON.stringify(schoolClass));
        localStorage.setItem("CurrentCourse", JSON.stringify(course));
        var url = config.Client + "/teacher/scores?scId=" + schoolClass.id+"&cId=" + course.id + "&mInd=" + month;
        window.open(url);
        setClassCourseVisible(false);
        setFieldDegreeVisible(true);
        // return;
        // var teacher = row.teacher;
        // if(teacher == null){
        //     setErorVisible(true);
        //     setErrorMessage("معلم نامشخص است");
        //     return;
        // }
        // setSchoolClassId(schoolClass.id);
        // setSchoolClassDegree(schoolClass.degree);
        // setCourseId(course.id);
        // setEditFormVisible(true);
    }
    const onContinualTestChanged = function (scId, cId){
        var tmp = {...classCourseList};
        for(var i=0;i<tmp.items.length;i++){
            var state = tmp.items[i];
            if((state.schoolClass.id == scId)&&(state.course.id == cId)){
            tmp.items[i].finalScoreIsDone = true;
            }
        }
        var id = scId+"_"+cId;
        var elm = document.getElementById(id);
        elm.innerHTML = '<div style="width:20px;height:20px;background-color:#44ee44;border-radius:50%"></div>';
        setClassCourseList(tmp);
    }
    return(      
      <>
      <ShowVideo videoId="create_print_gradesheet" top={65} md={6} /> 
        <div className="page-caption" style={{ width:"calc(100% - 0px)"}}>ایجاد کارنامه ماهانه</div>
        <div className="" style={{ width:"calc(100% - 0px)"}}>
          <div style={{backgroundColor:'#e9edffff', padding:'5px', borderRadius:'5px', width:"100%", display:'flow-root'}}>
              <Row>
                <Col md={3}>
                  <EduMonthCombo value={month} onChange={(value)=>{setMonth(value)}} />
                </Col>
              </Row>
          </div>
        </div>
        {
            fieldDegreeVisible?
            <>
                {
                    loadingFieldDegree?
                    <>
                    در حال خواندن لیست رشته و پایه ...
                    <Skeleton />
                    </>
                    :
                    <>
                    <table style={{width:"calc(100% - 10px)", margin:"10px 5px"}}>
                        <tbody>
                            <tr style={{borderBottom:"2px dashed #fac943ff"}}>
                                <td>رشته</td>
                                <td style={{width:"40px"}}>پایه</td>
                                <td style={{width:"120px"}}>&nbsp;</td>
                            </tr>
                            {
                                fieldDegreeList.map((row, index)=>{
                                    return(
                                        <tr style={{height:"60px", borderBottom:"2px dashed #fac943ff"}}>
                                            <td>{row.field.title}</td>
                                            <td>{row.degree}</td>
                                            <td>
                                                <Button icon="pi pi-check" label='ادامه' rounded severity="primary" style={{width:"100px", margin: "0px 3px", float:"right" }} onClick={() => {btnContinuClick(row)}} />
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                    </>
                }
            </>
            :
            <></>
        }
        {
            classCourseVisible?
            <>
            {
                loadingClassCourse?
                <>
                در حال خواندن لیست کلاس و درس ...
                <Skeleton />
                </>
                :
                <>
                    <Button icon="pi pi-check" label='انتخاب رشته-پایه' saving={saving} rounded severity="primary" style={{width:"200px", margin: "10px 3px", float:"right" }} onClick={() => {setClassCourseVisible(false);setFieldDegreeVisible(true);}} />
                    <table style={{width:"calc(100% - 10px)", margin:"10px 5px"}}>
                        <tbody>
                            <tr style={{borderBottom:"2px dashed #8c52f8ff", height:"70px"}}>
                                <td>کلاس</td>
                                <td>درس</td>
                                <td style={{width:"40px", position:"relative"}}>
                                    <div style={{transform:"rotate(270deg)", position:"absolute", top:"55px", left:"-15px", width:"90px"}}>نمرات</div>
                                </td>
                                <td style={{width:"40px", position:"relative"}}>
                                    <div style={{transform:"rotate(270deg)", position:"absolute", top:"55px", left:"-15px", width:"90px"}}>انضباط</div>
                                </td>
                                <td>&nbsp;</td>
                            </tr>
                            {
                                classCourseList.items.map((row, index)=>{
                                    return(
                                        <>
                                        <tr style={{height:"30px", borderTop:"2px dashed #8c52f8ff"}}>
                                            <td>{row.schoolClass.name}</td>
                                            <td>{row.course.name}</td>
                                            <td rowSpan={2} id={row.schoolClass.id+"_"+row.course.id}>
                                                {row.state.finalScoreIsDone?
                                                <div style={{width:"20px", height:"20px", backgroundColor:"#44ee44", borderRadius:"50%"}}></div>
                                                :
                                                <div style={{width:"20px", height:"20px", backgroundColor:"#ee4444", borderRadius:"50%"}}></div>
                                                }
                                            </td>
                                            <td rowSpan={2}>
                                                {row.state.disiplineScoreIsDone?
                                                <div style={{width:"20px", height:"20px", backgroundColor:"#44ee44", borderRadius:"50%"}}></div>
                                                :
                                                <div style={{width:"20px", height:"20px", backgroundColor:"#ee4444", borderRadius:"50%"}}></div>
                                                }
                                            </td>
                                            <td rowSpan={2}>
                                                {row.teacher== null?
                                                <>فاقد معلم و برنامه کلاسی</>:
                                                <>
                                                    <Button  onClick={() =>{EditTeacherScores(row);}} label='ثبت نمره معلم' rounded severity="success" style={{width:"140px", margin: "10px 3px", float:"right" }} />
                                                </>
                                                }
                                                
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colSpan={2}>
                                                {row.teacher== null?
                                                <></>:
                                                <>
                                                    {"[" + row.teacher.mobile + "] " + row.teacher.firstname + " " + row.teacher.lastname}
                                                </>
                                                }
                                            </td>
                                        </tr>
                                        </>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                    <hr/>
                    <table style={{width:"calc(100% - 10px)", margin:"10px 5px"}}>
                        <thead>
                            <tr>
                                <th style={{width:"200px", border:"1px solid #b0b0b0", backgroundColor:"#555", color:"#FFF", padding:"5px"}}>نام کلاس</th>
                                <th style={{width:"200px", border:"1px solid #b0b0b0", backgroundColor:"#555", color:"#FFF", padding:"5px"}}>تعداد کارنامه</th>
                                <th>&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                classList.map((cls, clsInd)=>{
                                    return(
                                        <tr>
                                            <td style={{border:"1px solid #b0b0b0", padding:"5px"}}>{cls.name}</td>
                                            <td style={{border:"1px solid #b0b0b0", padding:"5px"}}>{cls.count}</td>
                                            <td>&nbsp;</td>

                                        </tr>

                                    )
                                })
                            }
                        </tbody>
                    </table>
                    <hr/>
                    {
                        (classCourseList.finalScoresDone && classCourseList.finalDisiplinesDone)?
                        <table>
                            <tr>
                                <td style={{padding:"5px"}}><Button  onClick={() => {createGradeSheet(0);}} icon="pi pi-check" label='ایجاد کارنامه ها' rounded severity="success" loading={saving} style={{width:"200px", margin: "10px 3px", float:"right" }} /></td>
                                <td style={{padding:"5px"}}><Button  onClick={() => {createGradeSheetLevelsStart();}} icon="pi pi-check" label='ایجاد رتبه دانش آموزان' rounded severity="success" loading={saving} style={{width:"300px", margin: "10px 3px", float:"right" }} /></td>
                            </tr>
                            {
                            saveLevelAndGrade?
                            <>
                            <tr>
                                <td colSpan={2} style={{textAlign:"right"}}>
                                     در حال ثبت رتبه   {gradeSheetSettedGradeCount} کارنامه از {all_students_classes.length}
                                </td>
                            </tr>
                            <tr>
                                <td colSpan={2} style={{textAlign:"right"}}>
                                     <Skeleton />
                                </td>
                            </tr>
                            </>
                            :
                            <></>
                            }
                        </table>
                        
                        :
                        <></>
                    }
                    <br/><br/><br/>
                </>
            }            
            </>
            :
            <></>
        }

      {
        editFormVisible?
        <FinalScoreSave schoolClassId={schoolClassId} schoolClassDegree={schoolClassDegree} courseId={courseId} monthInd={parseInt(month)} isAgent={true} onChange={(scId, cId)=>{onContinualTestChanged(scId, cId)}} onClose={()=>setEditFormVisible(false)} />
        :
        <></>
      }

        <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
      </>  
    );
  
}
